import { render, staticRenderFns } from "./ClinicianManagement.vue?vue&type=template&id=4982f57c&scoped=true&"
import script from "./ClinicianManagement.vue?vue&type=script&lang=js&"
export * from "./ClinicianManagement.vue?vue&type=script&lang=js&"
import style0 from "./ClinicianManagement.vue?vue&type=style&index=0&id=4982f57c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982f57c",
  null
  
)

export default component.exports